<template>
  <div id="app">
    <nav class="navbar is-transparent is-dark is-fixed-top" v-if="showNav">
      <div class="navbar-brand">
        <a class="navbar-item" href="#">
          <img src="./assets/logo-small.png" alt="VMS - find a new path" height="28">
        </a>
        <div class="navbar-item page-name">
          {{ $route.name }}
        </div>
        <div class="navbar-burger burger" ref="burgers" @click="burgersClicked">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" ref="burgerTarget">
        <div class="navbar-end" v-if="user">
          <div class="navbar-item">Logged in as&nbsp;<b>{{ $store.getters.user }}</b></div>
          <div class="navbar-item">
            <div class="buttons">
              <a href="#" class="button" @click="onSignOut()">Sign Out</a>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="side-menu navbar-padding" v-if="showMenu">
      <aside class="menu">
        <ul class="menu-list">
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link :to="item.to" :class="$route.path == item.to ? 'active' : ''">{{ item.name }}</router-link>
          </li>
        </ul>
      </aside>
    </div>

    <div class="main-container" :class="{'side-menu-padding': showMenu, 'navbar-padding': showNav }">
      <router-view/>
    </div>

  </div>

</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      showNav: false,
      showMenu: false
    }
  },
  computed: {
    menuItems () { return this.$store.getters.menuItems.filter(item => item.side !== false) },
    user () { return this.$store.getters.user },
    routeMeta () { return this.$route.meta }
  },
  watch: {
    routeMeta () {
      this.updateShowing()
    }
  },
  methods: {
    onSignOut () {
      this.$api('signOut')
        .then(resp => {
          this.$router.push('/sign-in')
        })
        .catch(err => {
          console.error(err)
        })
    },
    burgersClicked () {
      this.$refs.burgers.classList.toggle('is-active')
      this.$refs.burgerTarget.classList.toggle('is-active')
    },
    updateShowing () {
      this.showNav = this.$route && (!this.$route.meta || this.$route.meta.showNav !== false)
      this.showMenu = this.$route && (!this.$route.meta || this.$route.meta.showMenu !== false)
    }
  }
}
</script>

<style>
#app > .navbar {
  border-bottom: solid 1px #999;
  z-index: 10;
}

#app .navbar-padding {
  padding-top: 52px;
}

#app .side-menu-padding {
  padding-left: 125px;
}

#app > .navbar .page-name {
  font-size: 1.2em;
  font-weight: bold;
}

#app .side-menu {
  position: fixed;
  height: 100%;
  min-width: 125px;
  background-color: #eee;
  border-right: solid 1px #ccc;
  z-index: 5;
}
#app .side-menu .active {
  font-weight: bold;
  /* background-color: #e2e2e2; */
}
</style>
